import React, { FC, memo } from 'react';
import { useField } from 'formik';

import usePrefix from 'utils/usePrefix';
import FormDescription from 'components/ResqlExpert/FormDescription';
import {
  FormSectionContentStyled,
  FormSectionStyled,
  TabBodyContentStyled,
} from 'components/ResqlExpert/SubmissionForm/styles';

import ExpertNote from '../ExpertNote';

interface Props {
  fieldName: string;
  commentFieldName: string;
  noteId: string;
  titleKey: string;
  hintKey: string;
}

const AdminSingleFieldTab: FC<Props> = ({
  fieldName,
  commentFieldName,
  noteId,
  titleKey,
  hintKey,
}) => {
  const t = usePrefix('ResqlExpert');
  const [originalField] = useField<string>(fieldName);
  const [commentField, , commentHelpers] = useField<string>(commentFieldName);

  return (
    <TabBodyContentStyled>
      <FormSectionStyled>
        <FormDescription title={t(titleKey)}>
          {hintKey ? (
            // eslint-disable-next-line react/no-danger
            <div dangerouslySetInnerHTML={{ __html: t(hintKey) }} />
          ) : null}
        </FormDescription>
        <FormSectionContentStyled>
          {originalField.value ? <p>{originalField.value}</p> : null}
          <ExpertNote
            id={noteId}
            value={commentField.value ?? ''}
            onChange={(v) => commentHelpers.setValue(v)}
          />
        </FormSectionContentStyled>
      </FormSectionStyled>
    </TabBodyContentStyled>
  );
};

export default memo(AdminSingleFieldTab);
